export const TrTable = ({children, bg='hover:bg-gray-100 bg-white'}) => {
    return (
        <tr className={`  flex justify-between sm:table-row flex-row sm:flex-row flex-wrap sm:flex-no-wrap mb-10 sm:mb-0 ${bg}`}>
            {children}
        </tr>
    )
}
 